import { purry } from './purry';
var _countBy = function (indexed) {
    return function (array, fn) {
        return array.reduce(function (ret, item, index) {
            var value = indexed ? fn(item, index, array) : fn(item);
            return ret + (value ? 1 : 0);
        }, 0);
    };
};
/**
 * Counts how many values of the collection pass the specified predicate.
 * @param fn The predicate.
 * @signature
 *    R.countBy(fn)(array)
 * @example
 *    R.pipe([1, 2, 3, 4, 5], R.countBy(x => x % 2 === 0)) // => 2
 * @data_last
 * @indexed
 * @category Array
 */
export function countBy() {
    return purry(_countBy(false), arguments);
}
(function (countBy) {
    function indexed() {
        return purry(_countBy(true), arguments);
    }
    countBy.indexed = indexed;
})(countBy || (countBy = {}));
